function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Credit Card 2");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Create-Listing",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Credit-Card-2"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 56,
  height: 38
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-7",
  fill: "#E6E6E6",
  x: 5,
  y: 22,
  width: 45,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-7",
  fill: "#E6E6E6",
  x: 5,
  y: 29,
  width: 19,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-7",
  fill: "#BFBFBF",
  x: 31,
  y: 9,
  width: 19,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-10",
  fillOpacity: 0.5,
  fill: "#F2C95B",
  x: 5,
  y: 7,
  width: 9,
  height: 9,
  rx: 2
})));

var SvgDefaultCreditCard = function SvgDefaultCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "38px",
    viewBox: "-5 -5 70 50",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDefaultCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/default-credit-card.5e7832ee.svg";
export { ForwardRef as ReactComponent };